import { CircleCheck } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useSearchParams } from "react-router";

import { useAuth } from "@/auth/use-auth";
import { Button } from "@/components/ui/button";

import { AuthLayout, FormAlert } from "./components";
import { PasswordChangeForm } from "./PasswordChangeForm";

/** `/reset?token=` — the link from the reset e-mail (single use, 30 min). */
export function ResetPage() {
  const { t } = useTranslation("auth");
  const { api } = useAuth();
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";
  const [done, setDone] = useState(false);

  if (done) {
    return (
      <AuthLayout title={t("reset.done_title")}>
        <div role="status" className="flex flex-col gap-3">
          <CircleCheck className="size-touch text-[#047857]" aria-hidden />
          <p>{t("reset.done_body")}</p>
          <Button asChild size="lg">
            <Link to="/login">{t("reset.sign_in")}</Link>
          </Button>
        </div>
      </AuthLayout>
    );
  }

  if (token.length < 16) {
    return (
      <AuthLayout title={t("reset.title")}>
        <FormAlert message={t("reset.missing_token")} />
        <Link to="/forgot" className="min-h-touch self-start py-2 underline underline-offset-4">
          {t("reset.ask_again")}
        </Link>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title={t("reset.title")}>
      <PasswordChangeForm
        withCurrent={false}
        submitLabel={t("reset.submit")}
        onSubmit={async ({ newPassword }) => {
          await api.resetPassword(token, newPassword);
          setDone(true);
        }}
      />
      <Link
        to="/forgot"
        className="min-h-touch self-start py-2 text-sm underline underline-offset-4"
      >
        {t("reset.ask_again")}
      </Link>
    </AuthLayout>
  );
}
